import styled from 'styled-components'

export const Wrapper = styled.span(({ theme }) => ({
  display: 'block',
  height: '1.6rem',
  marginTop: theme.space['2'],
  position: 'relative',
  width: '100%',
}))

// Note: Message is positioned absolutely to ensure it stays within the parent container
// thanks to it it doesn't change the layout
export const Message = styled.span(({ theme }) => ({
  color: theme.colors.red500,
  fontSize: '1.2rem',
  left: 0,
  lineHeight: '1.6rem',
  overflow: 'hidden',
  position: 'absolute',
  right: 0,
  textOverflow: 'ellipsis',
  top: 0,
  whiteSpace: 'nowrap',
}))
